import PropTypes from 'prop-types';
import React from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { FormattedMessage } from 'react-intl';
import cn from 'classnames';

import ScreenReaderMessage from '@bibliocommons/base-screen-reader-message';
import { Info } from '@bibliocommons/deprecated-base-icons';

export default function DigitalHelpLink({ policy, className, withIcons }) {
  return (
    <a
      href={policy.get('helpUrl')}
      target="_blank"
      rel="noopener noreferrer"
      className={cn('cp-digital-help-link', className)}
    >
      {withIcons && <Info />}
      <div>
        <FormattedMessage id="how_do_i_get_digital_checkout">
          {message => <span aria-hidden>{message}</span>}
        </FormattedMessage>
        <ScreenReaderMessage>
          <FormattedMessage id="ada_how_do_i_get_digital_checkout" />
        </ScreenReaderMessage>
      </div>
    </a>
  );
}

DigitalHelpLink.propTypes = {
  policy: ImmutablePropTypes.map,
  className: PropTypes.string,
  withIcons: PropTypes.bool
};
